import { Pagination } from "@mui/material";
import React from "react";

export default function CustomPagination({ page, setPage, count }) {
  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <Pagination
      count={count}
      page={page}
      onChange={handlePageChange}
      color="primary"
      size="large"
      shape="rounded"
      sx={{
        display: count > 0 ? "flex" : "none",
        direction: "ltr",
        alignItems: "center",
        zIndex: "100",

        "& .MuiPagination-ul": {
          direction: "ltr",
        },

        "& .MuiPaginationItem-root": {
          fontSize: "1rem",
          fontWeight: 500,
          borderRadius: "8px",
          direction: "ltr",
        },
      }}
    />
  );
}
